export const SORT_BY = {
  DATE_CREATED: 'createDatetime',
  DATE_UPDATED: 'updateDatetime',
  NAME: 'name',
  LABELS: 'labels',
  LIVE_REPORTS: 'liveReportEnabled',
  CREATED_BY: 'ownerName'
} as const

export const SORTING_LEVEL = [
  SORT_BY.DATE_CREATED,
  SORT_BY.DATE_UPDATED,
  SORT_BY.NAME,
  SORT_BY.LABELS,
  //   SORT_BY_SCHEDULED_REPORT,
  SORT_BY.LIVE_REPORTS,
  SORT_BY.CREATED_BY
]

export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export const LIMITED_DASHBOARD_CATEGORY = {
  recentlyViewedDashboards: 'recentlyViewedDashboards',
  allDashboards: 'allDashboards'
} as const

export const DASHBOARD_CATEGORY = {
  recentlyViewedDashboards: 'recentlyViewedDashboards',
  myDashboards: 'myDashboards',
  companyDashboards: 'companyDashboards',
  allDashboards: 'allDashboards'
} as const

export const TEMPLATE_CATEGORY = {
  myTemplates: 'myTemplates',
  companyTemplates: 'companyTemplates'
} as const

export const CATEGORY = {
  ...DASHBOARD_CATEGORY,
  ...TEMPLATE_CATEGORY
} as const
